import { List, UnstyledButton } from '@mantine/core';
import { useEffect, useState } from 'react';
import { FetchQuestionOptions } from '@mygpt/app/chat/hooks';

type PhoneList = Array<{ original_phone: string; encrypted_phone: string }>;

interface Props {
  onClick: (value: string, options?: FetchQuestionOptions) => void;
}

export const PhoneList = ({ onClick }: Props) => {
  const [phoneList, setPhoneList] = useState<PhoneList>([]);

  useEffect(() => {
    const timer = setInterval(() => {
      if (window && (window as any).hismobile_phone_list) {
        try {
          const data = (window as any).hismobile_phone_list;
          if (Array.isArray(data) && data.every((item) => item.original_phone && item.encrypted_phone)) {
            setPhoneList(data);
            clearInterval(timer);
          } else {
            console.warn(`Invalid phone number data format:`, data);
          }
        } catch (error) {
          console.warn('Failed to parse phone number data:', error);
        }
      }
    }, 500);

    return () => clearInterval(timer);
  }, []);

  if (!phoneList.length) return null;

  return (
    <section className="pt-5 pb-2 mt-5 mb-2 rounded-xl border-t border-gray-200">
      <List listStyleType="disc">
        {phoneList.map((phone) => (
          <List.Item key={phone.encrypted_phone} className="text-gray-500 hover:text-violet-700">
            <UnstyledButton
              className="text-sm text-gray-500 hover:text-violet-700 hover:underline focus:outline-none"
              onClick={() => {
                onClick(phone.original_phone);
              }}
            >
              {phone.original_phone}
            </UnstyledButton>
          </List.Item>
        ))}
      </List>
    </section>
  );
};
